// import ArrowUpRightIcon from "../../icons/ArrowUpRightIcon";

import { formatCryptoValue } from "../../utils/format";

const AssetValueChange = ({ asset }) => {
  if (asset.title) {
    return (
      <div className="flex flex-col items-end">
        <p className="text-sm font-medium leading-[19.5px] text-text-primary">
          {/* {asset.balance} */}
          {formatCryptoValue(asset?.balance, asset?.decimals || 8)}
        </p>
        <p className="w-full text-right text-[11px] font-normal leading-[16.5px] text-text-secondary">
          {asset.currency_code}
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-end">
      <p className="text-sm font-medium leading-[19.5px] text-text-primary">
        {asset.title}
      </p>
      {/* <div className={`flex items-center ${asset.positive ? "text-[#4ab932]" : "text-error-500"}`}>
        <span className={asset.positive ? "" : "rotate-180"}>
          <ArrowUpRightIcon size={16} />
        </span>
        <span className="text-xs font-medium leading-[19.5px]">
          {Math.abs(asset.change24h).toFixed(2)}%
        </span>
      </div> */}
    </div>
  );
};

const AssetPickerRow = ({ asset, onSelect, isSelected }) => (
  <button
    type="button"
    onClick={() => onSelect?.(asset)}
    className={`flex h-[70px] w-full shrink-0 flex-col items-start justify-center rounded-[12px] px-3 py-[15px] text-left custom-transition ${
      isSelected
        ? "bg-[rgba(74,185,50,0.1)]"
        : "bg-background-alt hover:bg-option-hover"
    }`}
  >
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="flex size-9 shrink-0 items-center justify-center overflow-hidden rounded-full">
          <img
            src={asset.logo}
            alt={asset.currency_code}
            className="size-9 rounded-full object-cover"
          />
        </div>
        <div className="flex flex-col gap-px">
          <p className="text-sm font-semibold leading-[19.5px] text-text-primary">
            {asset.currency_code}
          </p>
          <p className="text-xs font-normal leading-[16.5px] text-text-secondary">
            {asset.title}
          </p>
        </div>
      </div>
      <AssetValueChange asset={asset} />
    </div>
  </button>
);

const AssetPickerList = ({
  assets,
  onSelect,
  selectedAssetId,
  className = "",
}) => (
  <div
    className={`absolute left-0 top-full z-30 mt-1 h-[236px] border border-divider w-full overflow-hidden 
    rounded-xl bg-background-surface shadow-[0px_8px_16px_0px_rgba(0,0,0,0.16)] ${className}`}
  >
    <div className="flex h-full flex-col gap-[8px] overflow-y-auto px-0.5 pb-2 pt-1 pr-1 mr-1 custom-scrollbar">
      {assets.map((asset) => (
        <AssetPickerRow
          key={asset.id}
          asset={asset}
          onSelect={onSelect}
          isSelected={asset.id === selectedAssetId}
        />
      ))}
    </div>
  </div>
);

export default AssetPickerList;
